<template>

  <svg
    t="1640064969277"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3996"
    width="64"
    height="64"
  ><path d="M947.02933333 896.55466667H75.94666667a29.74933333 29.74933333 0 0 1-29.71733334-29.71733334V284.66133333A29.74933333 29.74933333 0 0 1 75.94666667 254.93333333h871.08266666a29.74933333 29.74933333 0 0 1 29.71733334 29.71733334v582.176a29.74933333 29.74933333 0 0 1-29.71733334 29.728z m-843.168-57.6h815.24266667V312.53333333H103.86133333z" p-id="3997" /><path d="M511.30666667 747.73333333c-94.848 0-172.02133333-77.16266667-172.02133334-172.02133333s77.16266667-172.02133333 172.02133334-172.02133333 172.02133333 77.16266667 172.02133333 172.02133333S606.15466667 747.73333333 511.30666667 747.73333333z m0-286.4a114.37866667 114.37866667 0 1 0 114.37866666 114.41066667 114.50666667 114.50666667 0 0 0-114.37866666-114.37866667zM248.32 130.656h526.144v57.64266667H248.32z" p-id="3998" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconSnapshot',
} as DefineComponent
</script>